export default __webpack_public_path__ + "static/media/Login.c23e7f00.png";